export const VIP_ITEM_PRICES = {
        PEDRA: 0.0005,
        MADEIRA: 0.0004,
        METAL: 0.001,
        Metal_Ore: 0.0007,
        Sulfur_Ore: 0.0012,
        SURFUR: 0.002,
        HQ: 0.015,
        High_Quality_Metal_Ore: 0.008,
        SCRAP: 0.01,
        CLOTH: 0.0015,
        COURO: 0.002,
        Animal_Fat: 0.001,
        Bone_Fragments: 0.0005,
        Low_Grade_Fuel: 0.006,
        Crude_Oil: 0.004,
        POLVORA: 0.004,
        CARVÃO: 0.0003,

        CORDA: 0.08,
        TUBO: 0.15,
        MOLA: 0.18,
        ENGRENAGEM: 0.2,
        LAMINA: 0.12,
        PLACA: 0.15,
        CHAPA: 0.18,
        Tech_Trash: 0.35,
        COMPUTADOR: 0.45,
        CAMERA: 0.35,
        "KIT DE COSTURA": 0.08,
        Semi_Automatic_Body: 0.35,
        SMG_Body: 0.35,
        "CORPO DE RIFLE": 0.45,
        Empty_Propane_Tank: 0.08,

        "5.56": 0.012,
        "5.56 DE ALTA": 0.018,
        "5.56 INCENCIARIA": 0.02,
        "5.56 EXPLOSIVA": 0.9,
        "9MM": 0.008,
        "9MM DE ALTA": 0.012,
        "9MM INCENDIARIA": 0.014,
        "12": 0.01,
        "12 BALOTE (VERDE)": 0.018,
        "12 INCENCIARIA (AZUL)": 0.018,
        "12 DE CANO DUPLO": 0.012,
        Handmade_Shell: 0.006,
        Nailgun_Nails: 0.004,
        Wooden_Arrow: 0.003,
        High_Velocity_Arrow: 0.006,

        /* —— Explosivos / raid (itens importantes — preços valorizados) —— */
        EXPLOSIVE: 0.28,
        Demolition_Charge: 3.2,
        Timed_Explosive_Charge: 5.5,
        C4: 5.5,
        ROCKET: 1.85,
        FOGUETE_LMF: 3.2,
        FOGUETE_INCENDIARIO: 1.65,
        GRANADA_FUMACA_40MM: 1.2,
        GRANADA_EXPLOSIVA_40MM: 1.85,
        MUNICAO_ANTIAEREA: 0.75,
        "ROCKET DE ALTA": 1.85,
        "ROCKET DE FOGO": 1.65,
        "ROCKET LAUCH": 5.0,
        Smoke_Rocket: 0.55,
        GRANADA: 0.6,
        "GRANADA DE LATA": 0.35,
        Smoke_Grenade: 0.22,
        Supply_Signal: 2.5,

        AK: 3.5,
        LR: 4.0,
        M249: 8.0,
        L96: 5.0,
        BOLT: 3.2,
        M39_Rifle: 3.5,
        SEMI: 1.8,
        THOMPSON: 1.8,
        SUB: 1.6,
        MP5: 2.4,
        M92: 1.8,
        PYTHON: 1.4,
        REVOLVER: 0.8,
        P2: 1.0,
        GLOCK: 1.1,
        SPAS: 2.5,
        Pump_Shotgun: 1.4,
        "PIPE (12 CASEIRA)": 0.7,
        Eoka_Pistol: 0.25,
        Crossbow: 0.45,
        Hunting_Bow: 0.25,
        Nailgun: 0.5,
        Flame_Thrower: 2.2,
        Grenade_Launcher: 4.0,

        JACKHAMMER: 2.2,
        MOTOSERRA: 2.0,
        "PICARETA DE FERRO": 0.5,
        "MACHADO DE FERRO": 0.5,
        Salvaged_Icepick: 0.75,
        Salvaged_Axe: 0.75,
        Hammer: 0.15,
        Building_Plan: 0.1,

        Metal_Facemask: 3.1,
        Metal_Chest_Plate: 3.3,
        Road_Sign_Jacket: 2.5,
        Road_Sign_Kilt: 2.4,
        Coffee_Can_Helmet: 2.5,
        Riot_Helmet: 2.05,
        Bucket_Helmet: 1.7,
        Hazmat_Suit: 2.75,
        Heavy_Plate_Helmet: 3.5,
        Heavy_Plate_Jacket: 3.9,
        Heavy_Plate_Pants: 3.7,
        Boots: 1.6,
        Leather_Gloves: 1.6,
        Hoodie: 1.6,
        Pants: 1.6,
        Jacket: 1.7,
        Night_Vision_Goggles: 2.8,
        Traje_Artico: 3.8,
        Traje_Ninja: 3.8,
        Traje_Nomade: 3.8,

        "PORTA BLINDADA": 2.4,
        "PORTA DUPLA BLINDADA": 3.8,
        "PORTA DE GARAGEM": 2.2,
        Sheet_Metal_Door: 0.8,
        Sheet_Metal_Double_Door: 1.2,
        Wooden_Door: 0.2,
        Wood_Double_Door: 0.3,
        Code_Lock: 0.7,
        Lock: 0.2,
        Tool_Cupboard: 0.5,
        Large_Wood_Box: 0.35,
        Wood_Storage_Box: 0.2,
        Locker: 1.0,
        Bed: 0.5,
        Sleeping_Bag: 0.15,
        Furnace: 0.45,
        "FORNALHA GRANDE": 1.8,
        REFINARIA: 2.0,
        Repair_Bench: 0.8,
        Research_Table: 1.0,
        Mixing_Table: 1.2,
        ESTAÇÃO: 1.5,

        Auto_Turret: 3.0,
        Flame_Turret: 0.9,
        Shotgun_Trap: 0.8,
        SENTRY: 3.0,
        "TRAP DE 12": 0.8,
        "TRAP DE FOGO": 0.9,
        Land_Mine: 0.85,
        Snap_Trap: 0.25,
        Search_Light: 0.6,
        Ceiling_Light: 0.25,
        Wind_Turbine: 2.8,
        Mining_Quarry: 3.5,
        Pump_Jack: 3.5,
        Vending_Machine: 1.2,

        MINI: 8.0,
        "HELI SCRAP": 14.0,
        "BARCO PRETO": 5.0,
        DRONE: 3.0,

        SERINGA: 0.12,
        MEDKIT: 0.35,
        Bandage: 0.03,
        "Anti-Radiation_Pills": 0.08,
        CHA: 0.25,
        "CHA 2": 0.4,
        "CHA DE MADEIRA": 0.35,
        "CHA DE MINERIO": 0.35,
        "CHA DE RADIAÇÃO": 0.35,
        "CHA DE VIDA": 0.3,
        "CHA DE VIDA 2": 0.45,
        Can_of_Beans: 0.04,
        Can_of_Tuna: 0.04,
        Pumpkin: 0.03,
        Corn: 0.03,
        Apple: 0.03,
        Blueberries: 0.03,

        /* —— Acessórios de arma (modestos vs. armas 1.6–8.0) —— */
        "8X": 0.42,
        HOLOGRAFICA: 0.28,
        "Mira Telescópica de 16x": 0.55,
        "Melhora de Recuo": 0.25,
        Simple_Handmade_Sight: 0.12,
        SILENCIADOR: 0.32,
        Muzzle_Brake: 0.2,
        Muzzle_Boost: 0.22,
        LASER: 0.16,
        Weapon_Flashlight: 0.18,
        carregador_estendido: 0.3,

        /* —— Armas: melee / utilidade —— */
        Bone_Club: 0.08,
        Bone_Knife: 0.06,
        Longsword: 0.35,
        Mace: 0.22,
        Machete: 0.18,
        Salvaged_Cleaver: 0.28,
        Salvaged_Sword: 0.32,
        Stone_Spear: 0.08,
        Wooden_Spear: 0.06,
        Flare: 0.05,

        /* —— Armadilhas —— */
        Floor_Spikes: 0.2,
        Reactive_Target: 0.35,
        Survival_Fish_Trap: 0.15,

        /* —— Comida —— */
        Bear_Meat: 0.025,
        Bear_Meat_Cooked: 0.04,
        Burned_Chicken: 0.01,
        Burned_Wolf_Meat: 0.01,
        Burnt_Bear_Meat: 0.01,
        Cactus_Flesh: 0.02,
        Chocolate_Bar: 0.06,
        Cooked_Chicken: 0.04,
        Cooked_Deer_Meat: 0.04,
        Cooked_Fish: 0.035,
        Cooked_Human_Meat: 0.03,
        Cooked_Pork: 0.04,
        Cooked_Wolf_Meat: 0.04,
        Corn_Clone: 0.05,
        Corn_Seed: 0.04,
        Empty_Can_Of_Beans: 0.005,
        Empty_Tuna_Can: 0.005,
        Granola_Bar: 0.05,
        Hemp_Clone: 0.05,
        Hemp_Seed: 0.04,
        Minnows: 0.025,
        Mushroom: 0.02,
        Pork: 0.025,
        Pumpkin_Plant_Clone: 0.05,
        Pumpkin_Seed: 0.04,
        Raw_Chicken_Breast: 0.025,
        Raw_Deer_Meat: 0.025,
        Raw_Fish: 0.02,
        Raw_Human_Meat: 0.02,
        Raw_Wolf_Meat: 0.025,
        Salt_Water: 0.005,
        Small_Trout: 0.03,
        Small_Water_Bottle: 0.02,
        Water: 0.01,
        Water_Jug: 0.025,
        Black_Raspberries: 0.03,
        Bota_Bag: 0.08,

        /* —— Componentes —— */
        Netting: 0.1,
        Tarp: 0.12,

        /* —— Construção —— */
        Barbed_Wooden_Barricade: 0.22,
        Barbeque: 0.28,
        "CAIXÃO": 0.55,
        Camp_Fire: 0.12,
        Chainlink_Fence: 0.35,
        Chainlink_Fence_Gate: 0.4,
        Chair: 0.18,
        Concrete_Barricade: 0.38,
        Door_Key: 0.05,
        Double_Sign_Post: 0.15,
        Drop_Box: 0.25,
        ESCADA: 0.2,
        Floor_Grill: 0.32,
        Fridge: 0.45,
        Huge_Wooden_Sign: 0.22,
        Large_Wooden_Sign: 0.18,
        Ladder_Hatch: 0.55,
        Landscape_Picture_Frame: 0.08,
        Large_Banner_Hanging: 0.18,
        Large_Banner_on_pole: 0.22,
        Large_Planter_Box: 0.2,
        Large_Water_Catcher: 0.5,
        Mail_Box: 0.15,
        "MESA 2": 1.0,
        "MESA 3": 1.4,
        Metal_Barricade: 0.42,
        Metal_horizontal_embrasure: 0.35,
        Metal_Shop_Front: 0.65,
        Metal_Vertical_embrasure: 0.35,
        Metal_Window_Bars: 0.28,
        "MURO DE MADEIRA": 0.32,
        "MURO DE PEDRA": 0.48,
        One_Sided_Town_Sign_Post: 0.18,
        "PORTÃO DE MADEIRA": 0.28,
        "PORTÃO DE PEDRA": 0.45,
        Portrait_Picture_Frame: 0.08,
        Prison_Cell_Gate: 1.2,
        Prison_Cell_Wall: 1.0,
        Reinforced_Glass_Window: 0.38,
        Reinforced_Window_Bars: 0.32,
        Rug: 0.12,
        Rug_Bear_Skin: 0.18,
        Salvaged_Shelves: 0.22,
        Sandbag_Barricade: 0.28,
        Shop_Front: 0.55,
        Single_Sign_Post: 0.12,
        Small_Planter_Box: 0.12,
        Small_Stash: 0.08,
        Small_Water_Catcher: 0.28,
        Small_Wooden_Sign: 0.1,
        Stone_Barricade: 0.32,
        Table: 0.2,
        Tall_Picture_Frame: 0.1,
        Two_Sided_Hanging_Sign: 0.16,
        Two_Sided_Ornate_Hanging_Sign: 0.22,
        Two_Sided_Town_Sign_Post: 0.2,
        Water_Barrel: 0.22,
        Water_Purifier: 0.35,
        Wood_Shutters: 0.12,
        Wooden_Barricade: 0.15,
        Wooden_Sign: 0.1,
        Wooden_Window_Bars: 0.14,
        XL_Picture_Frame: 0.12,
        XXL_Picture_Frame: 0.15,

        /* —— Elétrico —— */
        Lantern: 0.2,
        LANTERNA: 0.22,
        Tuna_Can_Lamp: 0.14,

        /* —— Ferramentas —— */
        Binoculars: 0.38,
        Rock: 0.01,
        Salvaged_Hammer: 0.32,
        Stone_Hatchet: 0.12,
        Stone_Pick_Axe: 0.12,
        Torch: 0.05,

        /* —— Itens / diversos —— */
        Acoustic_Guitar: 0.28,
        Candy_Cane: 0.04,
        "CARTÃO AZUL": 0.55,
        "CARTÃO VERDE": 0.45,
        "CARTÃO VERMELHO": 0.75,
        Human_Skull: 0.08,
        Large_Present: 0.45,
        Medium_Present: 0.28,
        Note: 0.01,
        "PEIDO DE VEIA": 0.35,
        Pookie_Bear: 0.06,
        Small_Present: 0.15,
        Small_Stocking: 0.08,
        Spinning_wheel: 0.22,
        SUPER_Stocking: 0.12,
        Wolf_Skull: 0.08,
        testgenerator: 1.8,

        /* —— Recursos —— */
        DIESEL: 0.008,

        /* —— Roupas (peças avulsas; full 7 usa Metal/Road Sign/Coffee Can acima) —— */
        Bandana_Mask: 1.35,
        Baseball_Cap: 1.37,
        Beenie_Hat: 1.35,
        Bone_Armor: 1.47,
        Bone_Helmet: 1.43,
        Boonie_Hat: 1.37,
        Burlap_Headwrap: 1.33,
        Burlap_Shirt: 1.33,
        Burlap_Shoes: 1.31,
        Burlap_Trousers: 1.33,
        Candle_Hat: 1.39,
        Hide_Boots: 1.37,
        Hide_Halterneck: 1.35,
        Hide_Pants: 1.39,
        Hide_Poncho: 1.41,
        Hide_Skirt: 1.37,
        Hide_Vest: 1.39,
        Improvised_Balaclava: 1.35,
        "Longsleeve_T-Shirt": 1.37,
        Miners_Hat: 1.43,
        Shirt: 1.35,
        Shorts: 1.33,
        "Snow_Jacket_-_Red": 1.53,
        "T-Shirt": 1.33,
        Tank_Top: 1.31,
        Wolf_Headdress: 1.45,
        Wood_Armor_Helmet: 1.47,
        Wood_Armor_Pants: 1.45,
        Wood_Chestplate: 1.53,
    };
